<div nz-row class="company-intro-image"></div>
<div class="company-message" style="height: 380px;">
  <div class="content">
    <p>“믿음, 내실을 추구하는 미래 지향적 기업”<br />
      현대그린테크 주식회사는 건전하고 기본원칙에 충실하며,<br />
      믿음과 내실을 추구하는 미래 지향적인 기업입니다<br />
    </p>
  </div>
</div>
<div nz-row class="company-intro-value">
  <div class="value-header" nz-row>
    <h5 class="align-center intro-title">Our Core Value</h5>
    <p class="align-center intro-message">현대그린테크의 가치</p>
  </div>
    <div class="value-body" nz-row>
      <div class="item" nz-col>
        <div class="image value-first"></div>
        <div class="message">
          <h5 class="intro-title">고객만족</h5>
          <p class="intro-message">고객의 입장에서 생각하고 작은<br />
            소리도 경청함으로써 고객을<br />
            만족시킬 수 있도록 최선을 다합니다.</p>
        </div>
      </div>
      <div class="item" nz-col style="margin-left: 74px; margin-right: 74px;">
        <div class="image value-second"></div>
        <div class="message">
          <h5 class="intro-title">정도경영</h5>
          <p class="intro-message">윤리경영을 기반으로 투명하고<br/>
            건전한 기업문화를 조성합니다.</p>
        </div>
      </div>
      <div class="item" nz-col>
        <div class="image value-third"></div>
        <div class="message">
          <h5 class="intro-title">가치창출</h5>
          <p class="intro-message">가치창조 활동을 통해 고객가치를<br/>
            극대화하고 구성원들의<br/>
            자아실현을 지향합니다.</p>
        </div>
      </div>
    </div>
</div>
<div nz-row class="company-slogan">
  <h5 class="align-center intro-title">Our Slogan</h5>
  <p class="align-center intro-message">현대그린테크의 슬로건</p>
  <div class="slogan-image"></div>
  <h5 class="align-center intro-title">
    3S (Small but Sound and Smart)<br/>
    작지만 건전하고 기본원칙에 충실한 기업
  </h5>
</div>
<div nz-row class="company-info">
  <div nz-row class="container">
    <!-- <div nz-row>
      <span nz-col></span>
      <span nz-col></span>
    </div> -->
    <p nz-col>
      기업명<br />
      설립일<br />
      대표이사<br />
      자본금<br />
      사업영역<br />
      매출액<br />
    </p>
    <p nz-col>
      현대그린테크 (주), Hyundai Green tech Co., Ltd<br/>
2006년 7월10일<br/>
대표이사 천명환, 정해수<br/>
6억원<br/>
반도체유통, 판금<br/>
1150억원(2023년)<br/>
    </p>
  </div>
  <div class="container">
    <p nz-col class="float-left">오시는 길</p>
    <p nz-col class="float-left">[서울 본사] 서울시 성동구 성수일로 4길 25, 1508호 (서울숲코오롱디지털타워 1차)<br />
      [천안 공장] 충남 천안시 서북구 입장면 흑암길 50</p>
  </div>
</div>
<div class="main-footer" nz-row>
  <p>COPYRIGHT BY (C) 2009 HYUNDAI GREEN TECH ALL RIGHTS RESERVED.<br/>
    [SEOUL]  T 02-2115-8815  F 02-2115-8818  [CHEON-AN] T 041-582-2214, 2215  F 041-588-2215</p>
</div>
